<template>
  <div>
    <div v-if="isCardList && socialPosts.list.length > 0">
      <div class="cards-wrapper" v-loading="loadingStatus" :element-loading-text="$t('portals.list.chargementDonnees')">
        <div v-for="result in socialPosts.list" :key="result.id" class="card">
          <!-- Header avec image et checkbox -->
          <div class="card-header">
            <el-checkbox
                class="checkbox-card"
                :value="selected.includes(result)"
                @change="value => toggleCard(result, value)"
            ></el-checkbox>
            <img v-if="result.photoPrincipale" :src="result.photoPrincipale.url" :srcset="result.photoPrincipale.url" class="card-image"/>
            <ubi-icon v-else-if="type === 'Editoriaux'" name="video-camera" size='180'/>
            <ubi-icon v-else name="camera" size='180'/>
          </div>

          <!-- Body avec toutes les informations -->
          <div class="card-body">
            <div class="card-content">
              <div class="card-info">
                <p><span class="subtitle">{{$t('posts.card.reference')}}:</span> {{ result.reference }} </p>
                <p><span class="subtitle">{{$t('posts.card.title')}}:</span> {{ capitalizeFirstLetter(result.titre) }} </p>
                <div class="component-icons-and-date">
                  <social-posts-list-table-presence-icons :post="result" :noDash="true"></social-posts-list-table-presence-icons>
                  <social-posts-list-table-presence :post="result" :noDash="true"></social-posts-list-table-presence>
                </div>
              </div>

              <!-- Actions dans la card -->
              <div class="card-actions">
                <div v-if="isPostFullyPublished(result)">
                  <em class="el-icon-view" :title="$t('socialPosts.list.viewOnly')" @click="viewPost(result)"></em>
                </div>
                <div v-else>
                  <em class="el-icon-edit-outline" :alt="$t('posts.edit.edit')" @click="editPost(result)"></em>
                  <em class="el-icon-delete" :alt="$t('posts.edit.remove')" v-if="shouldShowDeleteButton(result)" @click="deletePost(result)"></em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isCardList && socialPosts.list.length === 0">{{ $t('posts.card.noData')}}</div>
  </div>
</template>

<script>
import SocialPostsListTablePresenceIcons from '@/pages/socialNetworks/Blocks/SocialPostsListTablePresenceIcons.vue'
import SocialPostsListTablePresence from '@/pages/socialNetworks/Blocks/SocialPostsListTablePresence.vue'
import { capitalizeFirstLetter } from '@/helpers/capitalized'
import UbiIcon from '@/components/Icon.vue'

export default {
  name: 'SocialPostCard',
  components: {
    SocialPostsListTablePresence,
    SocialPostsListTablePresenceIcons,
    UbiIcon
  },
  props: {
    loadingStatus: {
      type: Boolean,
      required: true
    },
    socialPosts: {
      type: Object,
      required: true
    },
    selected: {
      type: Array,
      required: true
    },
    checkNbDiffusionsActives: {
      type: Function,
      required: false,
      default: () => () => 0 // Fonction par défaut qui retourne 0
    },
    isPostFullyPublished: {
      type: Function,
      required: false,
      default: () => () => false // Fonction par défaut qui retourne false
    },
    storeModule: {
      type: String,
      default: 'socialNetworkPosts'
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    isCardList () {
      return this.$store.getters[`${this.storeModule}/isCardList`]
    },
    isListView () {
      return this.$store.getters[`${this.storeModule}/isListView`]
    },
    isAllSelected () {
      return this.socialPosts.list.length > 0 && this.selected.length === this.socialPosts.list.length
    }
  },

  methods: {
    capitalizeFirstLetter,
    setViewMode (view) {
      this.$store.commit(`${this.storeModule}/setView`, view)
    },
    shouldShowDeleteButton (result) {
      // Le bouton de suppression n'est autorisé que pour les posts éditoriaux
      if (this.type !== 'Editoriaux') {
        return false
      }
      // Si la fonction checkNbDiffusionsActives n'est pas fournie, on n'affiche pas le bouton
      if (!this.checkNbDiffusionsActives || typeof this.checkNbDiffusionsActives !== 'function') {
        return false
      }
      return this.checkNbDiffusionsActives(result) === 0
    },

    toggleCard (card, isChecked) {
      let newSelected = [...this.selected]
      if (isChecked) {
        if (!newSelected.includes(card)) {
          newSelected.push(card)
        }
      } else {
        newSelected = newSelected.filter(s => s !== card)
      }
      this.$emit('update:selected', newSelected)
    },
    deletePost (selected) {
      this.$emit('delete-post', selected)
    },
    editPost (result) {
      this.$emit('edit-post', result)
    },
    viewPost (result) {
      this.$emit('view-post', result)
    }
  }
}
</script>

<style lang="css" scoped>
em.el-icon-delete:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}

em.el-icon-edit-outline:hover {
  color: #00a4bd !important;
  font-weight: bold;
  cursor: pointer;
}

em.el-icon-view {
  cursor: pointer;
  color: #606266 !important;
}

.cards-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
}

.card {
  width: 450px;
  border: 1px solid #ccc;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  transition: box-shadow 0.3s ease;
}

.card-header {
  position: relative;
  width: 100%;
  height: 200px;
  display: flex;
  background: #FFEFDF;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.card-header img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.card-body {
  padding: 15px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-info {
  flex-grow: 1;
  margin-bottom: 15px;
}

.card-info p {
  margin: 5px 0;
  color: #000;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-size: 14px;
  line-height: 1.4;
}

.subtitle {
  color: #184a56;
  line-height: 1.5;
  font-weight: 700;
  display: inline-block;
}

.component-icons-and-date {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

.card-actions em {
  font-size: 18px;
  cursor: pointer;
  padding: 5px;
  transition: all 0.3s ease;
}

.checkbox-card {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  padding: 2px;
}
</style>
